export var Top = 'top';
export var Left = 'left';
export var Right = 'right';
export var Bottom = 'bottom';



// WEBPACK FOOTER //
// ./~/vega-view-transforms/src/orient.js